import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import cn from 'classnames'
import BarcodeScannerComponent from 'react-qr-barcode-scanner'
import {
  FormControl,
  TextField,
  Button,
  IconButton,
  TextareaAutosize,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import isEqual from 'lodash/isEqual'
import { TABLET_BREAKPOINT } from 'helpers/responsive'
import { onFormInputEnterPress } from 'helpers/input'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import SidePopover from 'components/common/Popover/SidePopover'
import ImageModal from 'components/common/Modals/ImageModal'
import scan from 'assets/img/scan.svg'
import { showNotice } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import { ONLY_INTEGER_PATTERN } from 'constants/regExps'
import FuncHelper from 'helpers/functions'
import { equalMultiUnitValues } from './jobFieldsHelper'
import messages from '../translate'

class JobTextInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: '',
      oldValue: '',
      evtTaskInputId: '',
      showSidePopover: false,
      // TODO remove it after demo
      notificationMessage: '',
      isUpdating: false,
    }
  }

  componentDidMount() {
    const {
      inputData: { value, evtInputId },
    } = this.props

    // TODO remove it after demo
    this.setBarcodeNotificationMessage(value)

    this.setState({
      value: value || '',
      oldValue: value || '',
      evtTaskInputId: evtInputId,
    })
  }

  shouldComponentUpdate(nextProps) {
    const { inputInfo, inputData } = this.props
    const { inputInfo: nextInputInfo, inputData: nextInputData } = nextProps

    if (
      !isEqual(inputInfo, nextInputInfo) ||
      !isEqual(inputData, nextInputData)
    ) {
      const { value, evtInputId } = nextInputData

      // TODO remove it after demo
      this.setBarcodeNotificationMessage(value)

      this.setState({
        value: value || '',
        oldValue: value || '',
        evtTaskInputId: evtInputId,
      })

      return false
    }

    return true
  }

  componentDidUpdate(prevProps, prevState) {
    const { oldValue: prevOldValue } = prevState

    const {
      inputInfo: {
        parameters: { lookup_table_source },
      },
      inputData: { value },
    } = this.props
    if (
      lookup_table_source &&
      (!lookup_table_source?.parents ||
        lookup_table_source?.parents?.length === 1) &&
      (!value || value !== prevOldValue)
    ) {
      const {
        index: inputId,
        inputs,
        dependency: { currentEvtTask, evtTaskMatches },
        activeJobId,
        handleDependentLookupInputs,
      } = this.props

      handleDependentLookupInputs(
        inputs,
        evtTaskMatches || [currentEvtTask],
        inputId,
        activeJobId,
      )
    }
  }

  componentWillUnmount() {
    const { isUnitBlockOpen } = this.props

    if (isUnitBlockOpen) {
      this.onInputBlur()
    }
  }

  setResultId = ({ id }) => {
    this.setState({
      evtTaskInputId: id,
    })
  }

  handleInputFocus = () => {
    const { onJobTaskFocusedInput } = this.props

    onJobTaskFocusedInput(true)
  }

  onInputChange = e => {
    const { value } = e.target
    const { length } = value
    const {
      inputInfo: { parameters },
    } = this.props
    const maxLength = parameters.max_length || false

    if (maxLength && length > maxLength) return

    if (parameters.numbers_only) {
      if (ONLY_INTEGER_PATTERN.test(value) || value === '') {
        this.setState({ value })
      }

      return
    }

    this.setState({ value })
  }

  // // TODO remove it after demo
  setBarcodeNotificationMessage = value => {
    const {
      inputInfo: { workflow_input },
    } = this.props

    const id = 274583
    let notificationMessage = ''

    if (workflow_input && workflow_input === id && value === 'FRS1') {
      notificationMessage = 'Wrong Bin! Check Order details.'
    }

    this.setState({ notificationMessage })
  }
  // TODO end

  onInputBlur = () => {
    const {
      onJobTaskAutoSave,
      inputData: { evtInputId },
      inputInfo: {
        id,
        parameters: { min_length },
      },
    } = this.props
    const { value, oldValue, evtTaskInputId } = this.state

    if (value !== oldValue) {
      if (
        !min_length ||
        (min_length && (value.length >= min_length || !value.length))
      ) {
        this.setState(
          {
            isUpdating: true,
            oldValue: value,
          },
          () => {
            onJobTaskAutoSave(
              {
                evtInputId: evtInputId || evtTaskInputId,
                result: value || null,
                input: id,
                setResultId: this.setResultId,
              },
              () => {
                this.setState({
                  isUpdating: false,
                })
              },
            )
          },
        )
      }
    } else {
      this.setState({
        isUpdating: true,
      })

      onJobTaskAutoSave(false, () => {
        this.setState({
          isUpdating: false,
        })
      })
    }
  }

  handleScan = (err, result) => {
    if (result) {
      this.setState(
        {
          value: result.text,
          showSidePopover: false,
        },
        () => this.onInputBlur(),
      )
    }
  }

  handleError = error => {
    const {
      showNotice,
      intl: { formatMessage },
    } = this.props

    if (error) {
      showNotice({
        notice: NoticeHelper.createErrorObj(
          formatMessage(messages.cannotDetectTheQrCode),
        ),
      })
    }
  }

  onSwitchPopover = () => {
    const { showSidePopover } = this.state

    this.setState({
      showSidePopover: !showSidePopover,
    })
  }

  onCleanFieldValue = e => {
    e.preventDefault()
    this.setState({ value: '' }, () => this.onInputBlur())
  }

  getQrCodeScanner = () => {
    const {
      intl: { formatMessage },
    } = this.props
    const { showSidePopover } = this.state
    const scannerContent = (
      <div className="job-field-scanner-box">
        <div className="job-field-scanner-header">
          <IconButton
            className="job-field-close-button"
            onClick={this.onSwitchPopover}>
            <CloseIcon />
          </IconButton>
          <div className="job-field-scanner-text">
            {formatMessage(messages.scanQrBarcode)}
          </div>
        </div>
        <div className="job-field-scanner-inner">
          <div className="job-field-scanner-background" />
          <BarcodeScannerComponent
            onUpdate={(err, result) => this.handleScan(err, result)}
            onError={err => this.handleError(err)}
          />
        </div>
      </div>
    )

    return ifWindowWidthLessThan(TABLET_BREAKPOINT) ? (
      <SidePopover
        open={showSidePopover}
        close={this.onSwitchPopover}
        className="modal-content"
        position="bottom">
        <div className="modal-qr-scanner">{scannerContent}</div>
      </SidePopover>
    ) : (
      <ImageModal open={showSidePopover} onClose={this.onSwitchPopover}>
        <div className="modal-content">
          <div className="modal-qr-scanner image-wrap">{scannerContent}</div>
        </div>
      </ImageModal>
    )
  }

  getFieldSymbol = () => {
    const {
      inputInfo: { parameters },
    } = this.props
    let symbol = 'T'

    if (parameters.numbers_only) symbol = '#'

    return symbol
  }

  render() {
    const {
      disabled,
      className,
      multiChoiceMode,
      intl: { formatMessage },
      inputInfo: { title, parameters, required },
      inputData: { valueIsEqual },
      featureFlags,
      inputHint,
    } = this.props
    const { value, isUpdating, notificationMessage } = this.state
    const { min_length, max_length, longtext, barcode } = parameters
    const longTextInput = !!longtext
    const isInputDisabled = disabled || isUpdating
    const fieldWithLongText = longTextInput ? 5 : null
    const drawAsterisk = required ? '*' : ''
    const equalValuesPlaceholder = equalMultiUnitValues(
      multiChoiceMode,
      valueIsEqual,
    )

    const useFlexibleTextarea =
      featureFlags?.JOB_INPUT_FLEXIBLE_TEXT_ARIA && longTextInput
    const minRows = parameters?.min_rows || 5
    const maxRows = parameters?.max_rows || 200

    const inputSymbol = !longTextInput && (
      <span className="job-field-icon job-field-text-icon">
        {this.getFieldSymbol()}
      </span>
    )

    const getHelperText = () => {
      let helperText = ''

      if (!!max_length && value.length === max_length) {
        helperText = formatMessage(messages.maxCharsHint, {
          amount: max_length,
        })
      }

      if (value.length && value.length < min_length) {
        helperText = formatMessage(messages.minCharsHint, {
          amount: min_length,
        })
      }

      return helperText
    }

    let inputElement
    if (barcode) {
      inputElement = (
        <>
          <div className="job-field-scanner">
            <TextField
              value={value}
              disabled={isInputDisabled}
              placeholder={
                equalValuesPlaceholder
                  ? formatMessage(messages.enterTheDataOrScan)
                  : formatMessage(messages.valuesAreDifferent)
              }
              onChange={this.onInputChange}
              className="job-field-input-box"
              inputProps={{
                className: cn('job-field-input', {
                  'job-field-input-not-empty': value,
                }),
                onBlur: this.onInputBlur,
              }}
            />
            <Button
              href={null}
              disabled={isInputDisabled}
              variant="contained"
              color="primary"
              className="job-field-scanner-button"
              onClick={this.onSwitchPopover}>
              <img src={scan} alt="Scan" />
            </Button>
          </div>
          {this.getQrCodeScanner()}
          {value && (
            <IconButton
              className="job-field-clear-button"
              onMouseDown={e => this.onCleanFieldValue(e)}
              onTouchStart={e => this.onCleanFieldValue(e)}>
              <CloseIcon />
            </IconButton>
          )}
        </>
      )
    } else if (useFlexibleTextarea) {
      inputElement = (
        <TextField
          className="job-field-input-box"
          multiline
          variant="outlined"
          value={value}
          disabled={isInputDisabled}
          placeholder={
            equalValuesPlaceholder
              ? ''
              : formatMessage(messages.valuesAreDifferent)
          }
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          onFocus={this.handleInputFocus}
          helperText={getHelperText()}
          InputProps={{
            startAdornment: inputSymbol,
            inputComponent: TextareaAutosize,
            inputProps: {
              minRows,
              maxRows,
              className: cn('job-field-input', 'job-field-input-comment', {
                'js-enter-press-input': !isInputDisabled,
              }),
              onKeyUp: onFormInputEnterPress,
            },
          }}
        />
      )
    } else {
      inputElement = (
        <TextField
          multiline={longTextInput}
          rows={fieldWithLongText}
          value={value}
          disabled={isInputDisabled}
          placeholder={
            equalValuesPlaceholder
              ? ''
              : formatMessage(messages.valuesAreDifferent)
          }
          onChange={this.onInputChange}
          className="job-field-input-box"
          InputProps={{
            startAdornment: inputSymbol,
          }}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{
            className: cn('job-field-input', {
              'job-field-input-comment': longTextInput,
              'js-enter-press-input': !isInputDisabled,
              longTextInput,
            }),
            onBlur: this.onInputBlur,
            onKeyUp: onFormInputEnterPress,
            onFocus: this.handleInputFocus,
          }}
          helperText={getHelperText()}
        />
      )
    }

    return (
      <FormControl
        fullWidth
        className={cn(className, { warning: notificationMessage })}>
        <span className="job-field-label">
          {title} {drawAsterisk}
        </span>
        <div className="job-field-wrapper">
          {inputElement}
          {inputHint}
        </div>
        {notificationMessage && (
          <span className="job-field-alert-text">{notificationMessage}</span>
        )}
      </FormControl>
    )
  }
}

JobTextInput.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  inputData: PropTypes.shape({
    evtInputId: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.number),
      PropTypes.number,
    ]),
    value: PropTypes.string,
  }),
  isUnitBlockOpen: PropTypes.bool,
  onJobTaskAutoSave: PropTypes.func,
  showNotice: PropTypes.func,
  inputInfo: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    title: PropTypes.string,
    constant_value: PropTypes.string,
    options: PropTypes.array,
    position: PropTypes.number,
    required: PropTypes.bool,
    parameters: PropTypes.shape({
      min_length: PropTypes.number,
      max_length: PropTypes.number,
      longtext: PropTypes.bool,
      barcode: PropTypes.bool,
    }),
  }),
  featureFlags: PropTypes.shape({
    JOB_INPUT_FLEXIBLE_TEXT_ARIA: PropTypes.bool,
  }).isRequired,
}

JobTextInput.defaultProps = {
  onJobTaskAutoSave: FuncHelper.emptyFunc(),
  showNotice: FuncHelper.emptyFunc(),
  isUnitBlockOpen: false,
  inputData: {},
  inputInfo: {
    parameters: {},
  },
}

export default connect(
  state => ({
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
  }),
  {
    showNotice,
  },
)(injectIntl(JobTextInput))
